module.exports = __webpack_public_path__ + "img/23.bb4a8a70.webp";